import type { ValueConfig } from "@smartsuite/automation-engine-api";

export const checkIfConfigIncludeListOfList = (
  config: ValueConfig,
): boolean => {
  return config.values.some((value) => {
    if (value.value.oneofKind === "list") {
      return value.value.list.values.some((val) => {
        if (val.values.some((v) => v.value.oneofKind === "list")) {
          return true;
        }
        return checkIfConfigIncludeListOfList(val);
      });
    }
    if (
      value.value.oneofKind === "keyValue" &&
      value.value.keyValue.value !== undefined
    ) {
      return checkIfConfigIncludeListOfList(value.value.keyValue.value);
    }
    return false;
  });
};

export const checkDepthOfConfig = (config: ValueConfig): number => {
  return config.values.reduce((acc, value) => {
    if (value.value.oneofKind === "list") {
      return Math.max(
        acc,
        1 +
          value.value.list.values.reduce((acc, val) => {
            return Math.max(acc, checkDepthOfConfig(val));
          }, 0),
      );
    }
    if (
      value.value.oneofKind === "keyValue" &&
      value.value.keyValue.value !== undefined
    ) {
      return Math.max(acc, 1 + checkDepthOfConfig(value.value.keyValue.value));
    }
    return acc;
  }, 0);
};
